<script>
import { toThaiDatetime } from '@/utils/datetime'

export default {
  props: {
    status: {
      type: String,
      default: ''
    },

    date: {
      type: Date,
      default: null
    },

    branch: {
      type: String,
      default: ''
    },

    transferee: {
      type: String,
      default: ''
    },

    note: {
      type: String,
      default: ''
    }
  },

  render() {
    const Tag = ({ props }) => {
      const getTag = type => {
        switch (type) {
          case 'accepted':
            return {
              label: 'รับแล้ว',
              type: 'success'
            }

          case 'canceled':
            return {
              label: 'ยกเลิก',
              type: 'danger'
            }
        }
      }

      const tag = getTag(props.type)

      return (
        tag && (
          <el-tag
            type={tag.type}
            style={{ fontWeight: 'bold', fontSize: '1em' }}
          >
            {tag.label}
          </el-tag>
        )
      )
    }

    const Text = ({ slots }) => (
      <div style={{ lineHeight: '1.5' }}>{slots().default}</div>
    )

    return (
      <el-card>
        <el-form>
          <el-form-item label="สถานะ:" class={this.$style.formItem}>
            <Tag type={this.status} />
          </el-form-item>
          <el-form-item label="วันที่โอน:" class={this.$style.formItem}>
            <Text>{toThaiDatetime(this.date)}</Text>
          </el-form-item>
          <el-form-item label="สาขา:" class={this.$style.formItem}>
            <Text>{this.branch}</Text>
          </el-form-item>
          <el-form-item label="ผู้รับโอน:" class={this.$style.formItem}>
            <Text>{this.transferee}</Text>
          </el-form-item>
          {this.status === 'canceled' && (
            <el-form-item label="เหตุผล:" class={this.$style.formItem}>
              <Text>{this.note}</Text>
            </el-form-item>
          )}
        </el-form>
      </el-card>
    )
  }
}
</script>

<style lang="scss" module>
.formItem {
  display: flex;
  align-items: center;

  :global(.el-form-item__label) {
    min-width: 6rem;
  }
}
</style>
